
import isEmail from '~/utils/validations/email'
export default {
  data() {
    return {
      valid: !0,
      form: {
        name: '',
        email: '',
        message: ''
      },
      rules: {
        name: [(v) => !!v || 'Nome é obrigatório'],
        email: [
          (v) => !!v || 'E-mail é obrigatório',
          (v) => isEmail(v) || 'E-mail deve ser válido'
        ],
        message: [(v) => !!v || 'Mensagem é obrigatória']
      },
      lazy: !1
    }
  },
  computed: {
    height() {
      let size = 180,
        { xs, sm, mdAndUp } = this.$vuetify.breakpoint
      if (xs) size = 180
      else if (sm) size = 190
      else if (mdAndUp) size = 260
      return size
    },
    color() {
      const { themes } = site
      return this.$vuetify.theme.isDark ? themes.dark : themes.light
    }
  },
  methods: {
    async validate() {
      if (this.$refs.form.validate()) {
        const r = await this.$store.dispatch('app/sendEmail', this.form)
        if (r.msg) {
          this.$alert.success('Email enviado com sucesso.')
          this.form = {
            name: '',
            email: '',
            message: ''
          }
        } else {
          this.$alert.error('Email não enviado')
        }
      }
    }
  }
}
